import { useSyncExternalStore } from "react";
const useExternalStore = (store, selector) => selector(useSyncExternalStore(store.subscribe, store.getState));
export default useExternalStore;
